import { PerfilAcessoBardo } from '@nomoh-monorepo/shared-types';

/**
 * A partir de 2026-07-16 (Opção B — docs/perfil/PROPOSTA_FLAG_PRESTA_ATENDIMENTO.md),
 * serviço/expediente obrigatórios dependem de `prestaAtendimento`, não mais
 * diretamente do `perfilAcesso` (substitui a Opção A, que tratava RECEPCAO
 * como caso especial hardcoded).
 */
export function servicosObrigatorios(prestaAtendimento?: boolean | null): boolean {
  return !!prestaAtendimento;
}

export function expedienteObrigatorio(
  prestaAtendimento?: boolean | null,
  servicosSelecionados?: unknown[] | null
): boolean {
  if (prestaAtendimento) {
    return true;
  }

  return !!servicosSelecionados?.length;
}

/**
 * PROFISSIONAL sempre presta atendimento (decisão #1, 2026-07-16) — o campo
 * não é editável pelo usuário para esse perfil.
 */
export function prestaAtendimentoEditavel(
  perfilAcesso?: PerfilAcessoBardo | string | null
): boolean {
  return perfilAcesso !== 'PROFISSIONAL';
}

/**
 * Sugestão de valor inicial do toggle "Presta atendimento?" ao selecionar um
 * perfilAcesso (cadastro novo) — RECEPCAO sugere `false`, demais perfis
 * (inclusive futuros) sugerem `true`. Sempre editável, exceto PROFISSIONAL
 * (ver prestaAtendimentoEditavel) — regra por exclusão, não por lista de
 * perfis (decisão #2, 2026-07-16).
 */
export function prestaAtendimentoSugerido(
  perfilAcesso?: PerfilAcessoBardo | string | null
): boolean {
  return perfilAcesso !== 'RECEPCAO';
}
